import {
  resolveShiftFromScheduleCellFromMaps,
  type ShiftLookupMaps,
} from "@/utils/shift-util";

/**
 * 원티드 조정 엔트리의 `shifts_table_id`는 스케줄 API `schedule_ids`와 동일하게
 * 시프트 정의 행 DB id(`availableShifts[].id`)를 가리킨다.
 * 도메인 이름만 다를 뿐, 해석 규칙은 `resolveShiftFromScheduleCellFromMaps`와 같다.
 */
export function resolveShiftFromWantedEntry<
  T extends {
    shift_id: string;
    default_shift?: string | null;
    sequence?: number;
    id?: number;
  },
>(
  entry: { shift_id: string; shifts_table_id?: number | null },
  maps: ShiftLookupMaps<T>
): T | undefined {
  const numericId =
    entry.shifts_table_id != null &&
    Number.isFinite(Number(entry.shifts_table_id))
      ? Number(entry.shifts_table_id)
      : null;
  return resolveShiftFromScheduleCellFromMaps(entry.shift_id, numericId, maps);
}
